import { toggleClass } from '@studiometa/js-toolkit/utils';
import ListingBase from './ListingBase.js';
import ListingLetters from './ListingLetters.js';
import ListingTags from './ListingTags.js';

/**
 * Listing Accordions component
 */
export default class ListingAccordions extends ListingBase {
  static config = {
    name: 'ListingAccordions',
    refs: ['sections[]', 'empty'],
    options: {
      parameters: {
        type: Array,
      },
    },
    components: {
      ...ListingBase.config.components,
      ListingLetters,
      ListingTags,
    },
  };

  shuffleInstances = [];

  /**
   * Mounted
   */
  mounted() {
    const matchingAllItems = [...this.$el.querySelectorAll('.js-match-all-items')];

    matchingAllItems.forEach((matchingAllItem) => {
      const matchingSingleItem = [...matchingAllItem.querySelectorAll('.js-match-single-item')];

      matchingSingleItem.forEach((singleItem) => {
        this.$options.parameters.forEach((parameter) => {
          const target = singleItem.querySelector(`[data-${parameter}]`);
          if (!target) return;

          singleItem.dataset[parameter] = target.dataset[parameter];
        });
      });
    });

    this.setup();
    this.setupListeners();
  }

  /**
   * Get fields data
   * @returns {object} data
   */
  getData() {
    const data = Object.fromEntries(
      this.fields
        .filter((field) => field.value && field.value !== '-1')
        .map((field) => [field.name, field.value]),
    );

    return data;
  }

  /**
   * Update the listing on fields change
   */
  onFieldsChange() {
    const data = this.getData();

    const matchingAllItems = [...this.$el.querySelectorAll('.js-match-all-items')];

    const count = matchingAllItems.filter((matchingAllItem) => {
      const matchingSingleItem = [...matchingAllItem.querySelectorAll('.js-match-single-item')];

      const itemsToDisplay = matchingSingleItem.filter((singleItem) => {
        return this.$options.parameters.every((parameter) => {
          // Replace - with _ to match drupal taxonomies. Ex: entry_level ≠ entry-level
          const p = parameter.replace('-', '_');
          // Convert to camelCase since data-entry-level is dataset.entryLevel in js.
          return data[p]
            ? singleItem.dataset[this.toCamel(parameter)] &&
                singleItem.dataset[this.toCamel(parameter)].includes(data[p])
            : true;
        });
      });

      matchingSingleItem.forEach((el) => {
        el.style.display = 'none';
      });

      itemsToDisplay.forEach((el) => {
        el.style.display = '';
      });

      const shouldDisplay = itemsToDisplay.length > 0;
      matchingAllItem.style.display = shouldDisplay ? '' : 'none';

      return shouldDisplay;
    }).length;

    toggleClass(this.$refs.empty, 'hidden', count > 0);
  }

  /**
   * Convert a string to camelCase
   * @param {string} s the string to convert
   * @returns {string}
   */
  toCamel(s) {
    return s.replaceAll(/([-_][a-z])/gi, ($1) => {
      return $1.toUpperCase().replace('-', '').replace('_', '');
    });
  }

  /**
   * Filter elements by search
   * @param {Event} e
   */
  onSearchChange(e) {
    const data = this.getData();

    const searchText = e.target.value.toLowerCase().trim();

    this.shuffleInstances.forEach((instance) => {
      instance.filter((el) => {
        const matchData = this.$options.parameters.every((parameter) =>
          data[parameter]
            ? el.dataset[parameter] && el.dataset[parameter].includes(data[parameter])
            : true,
        );

        const matchSearchText = el.dataset.search
          ? el.dataset.search.toLowerCase().trim().includes(searchText)
          : true;

        return matchData && matchSearchText;
      });
    });
  }

  /**
   * Reset filters and trigger change
   */
  onListingPanelReset() {
    super.onListingPanelReset();
    this.onFieldsChange();
  }

  /**
   * Trigger filter on letters change
   */
  onListingLettersChange() {
    this.onFieldsChange();
  }

  /**
   * Trigger filter on tags change
   */
  onListingTagsChange() {
    this.onFieldsChange();
  }
}
